module.exports = "<div class=row> <tabs> <tab label=\"Test 1\"> Test 1 Page </tab> <tab label=\"Test 2\" acitve> Test 2 Page </tab> <tab label=\"Disabled Tab\" disabled=disabled> Test 3 page </tab> <tab label=\"Test 4\"> Test 4 page </tab> </tabs> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/tabs/tabs-demo.vue
 ** module id = 334
 ** module chunks = 0
 **/